/**
 * Header navigation: dropdown panels and the mobile burger panel.
 */
export default function nav() {
    var header = document.querySelector('.hdr');
    var navEl = document.querySelector('.nav');

    function syncHeaderMenu() {
        if (header) { header.classList.toggle('hdr--menu', !!(navEl && navEl.classList.contains('open'))); }
    }

    function closeMenus(except) {
        var open = document.querySelectorAll('.navtop[aria-expanded="true"]');
        for (var i = 0; i < open.length; i++) {
            if (open[i] !== except) { open[i].setAttribute('aria-expanded', 'false'); }
        }
    }

    document.addEventListener('click', function (event) {
        var top = event.target.closest('.navtop');
        if (top) {
            var isOpen = top.getAttribute('aria-expanded') === 'true';
            closeMenus(top);
            top.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            return;
        }
        if (!event.target.closest('.navmenu')) { closeMenus(); }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { closeMenus(); }
    });

    var burger = document.querySelector('.burger');
    if (!burger || !navEl) { return; }

    if (!burger.hasAttribute('aria-expanded')) { burger.setAttribute('aria-expanded', 'false'); }
    if (!navEl.id) { navEl.id = 'site-nav'; }
    burger.setAttribute('aria-controls', navEl.id);

    function setNav(open) {
        navEl.classList.toggle('open', open);
        syncHeaderMenu();
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.textContent = open ? 'Close' : 'Menu';
    }

    burger.addEventListener('click', function (event) {
        event.stopPropagation();
        setNav(!navEl.classList.contains('open'));
    });

    navEl.addEventListener('click', function (event) {
        if (event.target.closest('a')) { setNav(false); }
    });

    document.addEventListener('click', function (event) {
        if (!navEl.classList.contains('open')) { return; }
        if (event.target.closest('.nav') || event.target.closest('.burger')) { return; }
        setNav(false);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { setNav(false); }
    });

    // Leaving the mobile range must not strand an open panel.
    var mq = window.matchMedia('(min-width:1061px)');
    if (mq.addEventListener) {
        mq.addEventListener('change', function (event) {
            if (event.matches) { setNav(false); }
        });
    }
}
